let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kAF19")).then(() => parcelRequire('bPjbr'));